import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import logo from "../imagenes/logomadlex.png";
import CurrentUser from "./CurrentUser";

export const MODULOS_DICT = {
  Moneda: "Divisas",
  TipoProceso: "Tipo Proceso",
  TipoTribunal: "Tipo Tribunal",
  RolTribunal: "Rol Tribunal",
  Pais: "Paises",
  ContactoTipo: "Tipo Contacto",
  ContactoClase: "Clase Contacto",
  Direccion: "Direcciones",
  GeoAdmin: "Localización",
  DireccionUnidad: "Tipo de unidad de dirección",
  TipoDireccion: "Tipo de Dirección",
  PersonaEmpresa: "Tipo de Dirección",
  Etapa: "Tipo de Dirección",
  ConceptoDeuda: "Tipo de Dirección",
  Activo: "Tipo de Activos",
  OrigenDatos: "Origen de datos",
  CargaMasiva: "Carga Masiva",
  ResultadosCarga: "Carga Masiva",
  ConceptoGasto: "Concepto de Gasto",
  ResultadoGestiones: "Resultados de Gestiones",
  TipoGestiones: "Tipo de Gestiones",
  TraspasoDeudas: "Causas",
  BusquedaCausas: "Causas",
};

// Iconos SVG inline (heroicons style)
const Icons = {
  home: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
    </svg>
  ),
  search: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
    </svg>
  ),
  transfer: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
    </svg>
  ),
  upload: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
    </svg>
  ),
  download: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
    </svg>
  ),
  chart: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    </svg>
  ),
  settings: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
};

const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
};

const Sidebar = (props) => {
  const { history } = props;
  const [usuario] = useState(CurrentUser.user);
  const currentPath =
    (history.location && history.location.pathname) || "";

  const isActive = (route) => currentPath === route;

  // Auto-expand la sección que contiene la ruta actual
  const sectionContainsActive = (routes) =>
    routes.some((r) => currentPath === r);

  const [expandedSections, setExpandedSections] = useState(() => ({
    usuarios: sectionContainsActive(["/Usuarios", "/Perfiles"]),
    tribunales: sectionContainsActive([
      "/Tribunal",
      "/TipoTribunal",
      "/RolTribunal",
    ]),
    geografia: sectionContainsActive(["/Pais", "/Estados", "/GeoAdmin"]),
    direcciones: sectionContainsActive([
      "/Direccion",
      "/DireccionUnidad",
      "/TipoDireccion",
    ]),
    contactos: sectionContainsActive(["/ContactoTipo", "/ContactoClase"]),
    personas: sectionContainsActive([
      "/PersonaEmpresa",
      "/Relaciones",
      "/Activo",
    ]),
    clientes: sectionContainsActive(["/Cliente", "/Cartera"]),
    procesos: sectionContainsActive([
      "/TipoProceso",
      "/Etapa",
      "/ConceptoDeuda",
      "/ConceptoGasto",
      "/Titulos",
      "/OrigenDatos",
    ]),
    gestiones: sectionContainsActive([
      "/TipoGestiones",
      "/ResultadoGestiones",
    ]),
    otros: sectionContainsActive(["/Moneda", "/Unidades"]),
  }));

  const toggleSection = (key) => {
    setExpandedSections((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // Rutas que cualquier usuario logueado puede acceder sin necesidad de
  // tenerlas en su lista de modulosAdministracion. El control de acceso real
  // de cada una se hace dentro de la propia pagina (p.ej. KPI valida con
  // QuickSight si el usuario esta registrado como Reader).
  const OPEN_ROUTES = new Set(["Separacion", "Kpi"]);

  const changePage = (param) => {
    const route = param.startsWith("/") ? param.slice(1) : param;
    if (OPEN_ROUTES.has(route)) {
      return history.push("/" + route);
    }
    if (
      usuario &&
      usuario.modulosAdministracion &&
      usuario.modulosAdministracion.indexOf(route) === -1 &&
      usuario.modulosAdministracion.indexOf(MODULOS_DICT[route]) === -1
    ) {
      alert("No tienes acceso a ese modulo");
    } else {
      history.push("/" + route);
    }
  };

  const NavItem = ({ icon, label, route }) => (
    <div
      className={`sidebarNavItem ${isActive(route) ? "is-active" : ""}`}
      onClick={() => changePage(route)}
    >
      <span className="sidebarNavIcon">{icon}</span>
      <span className="sidebarNavLabel">{label}</span>
    </div>
  );

  const SubItem = ({ label, route }) => (
    <div
      className={`sidebarSubItem ${isActive(route) ? "is-active" : ""}`}
      onClick={() => changePage(route)}
    >
      {label}
    </div>
  );

  // Sección colapsable con sub-header clicable
  const CollapsibleSection = ({ id, title, children }) => {
    const isOpen = expandedSections[id];
    return (
      <div className="sidebarSection">
        <div
          className={`sidebarSectionTitle sidebarSectionTitle--collapsible ${
            isOpen ? "is-expanded" : ""
          }`}
          onClick={() => toggleSection(id)}
        >
          <span>{title}</span>
          <span className="sidebarSectionChevron">▾</span>
        </div>
        {isOpen && <div className="sidebarSectionItems">{children}</div>}
      </div>
    );
  };

  // Footer compartido con avatar de usuario
  const Footer = () =>
    usuario && usuario.account ? (
      <div className="sidebarFooter">
        <div className="sidebarUserAvatar">{getInitials(usuario.account.name)}</div>
        <div className="sidebarUserInfo">
          <div className="sidebarUserName">{usuario.account.name}</div>
          <div className="sidebarUserEmail">{usuario.account.username}</div>
        </div>
      </div>
    ) : null;

  // tipo="1" = Procesos de cobranza (Causas Judiciales)
  if (props.tipo === "1") {
    return (
      <nav className="navbar navbar-inverse sidebar" id="sidebarHover" role="navigation">
        <div className="sidebarBrand" onClick={() => changePage("/Separacion")}>
          <img alt="logo" id="logo" src={logo} />
        </div>

        <div className="sidebarBody">
          <div className="sidebarSection">
            <div className="sidebarSectionTitle">PRINCIPAL</div>
            <NavItem icon={Icons.home} label="Inicio" route="/Separacion" />
          </div>

          <div className="sidebarSection">
            <div className="sidebarSectionTitle">PROCESOS DE COBRANZA</div>
            <NavItem icon={Icons.search} label="Búsqueda de causas" route="/BusquedaCausas" />
            <NavItem icon={Icons.transfer} label="Traspaso de deudas" route="/TraspasoDeudas" />
          </div>

          <div className="sidebarSection">
            <div className="sidebarSectionTitle">CARGA</div>
            <NavItem icon={Icons.upload} label="Carga Masiva" route="/CargaMasiva" />
            <NavItem icon={Icons.download} label="Resultados de Carga" route="/ResultadosCarga" />
          </div>

          <div className="sidebarSection">
            <div className="sidebarSectionTitle">REPORTES</div>
            <NavItem icon={Icons.chart} label="KPI" route="/Kpi" />
          </div>
        </div>

        <Footer />
      </nav>
    );
  }

  // tipo="2" = Mantenedores
  if (props.tipo === "2") {
    return (
      <nav className="navbar navbar-inverse sidebar" id="sidebarHover" role="navigation">
        <div className="sidebarBrand" onClick={() => changePage("/Separacion")}>
          <img alt="logo" id="logo" src={logo} />
        </div>

        <div className="sidebarBody">
          <div className="sidebarSection">
            <div className="sidebarSectionTitle">PRINCIPAL</div>
            <NavItem icon={Icons.home} label="Inicio" route="/Separacion" />
          </div>

          <CollapsibleSection id="usuarios" title="USUARIOS Y PERFILES">
            <SubItem label="Usuarios" route="/Usuarios" />
            <SubItem label="Perfiles" route="/Perfiles" />
          </CollapsibleSection>

          <CollapsibleSection id="tribunales" title="TRIBUNALES">
            <SubItem label="Tribunal" route="/Tribunal" />
            <SubItem label="Tipo tribunal" route="/TipoTribunal" />
            <SubItem label="Libro/Tipo" route="/RolTribunal" />
          </CollapsibleSection>

          <CollapsibleSection id="geografia" title="GEOGRAFÍA">
            <SubItem label="País" route="/Pais" />
            <SubItem label="Estados" route="/Estados" />
            <SubItem label="Localizaciones" route="/GeoAdmin" />
          </CollapsibleSection>

          <CollapsibleSection id="direcciones" title="DIRECCIONES">
            <SubItem label="Direcciones" route="/Direccion" />
            <SubItem label="Unidad de dirección" route="/DireccionUnidad" />
            <SubItem label="Tipo de dirección" route="/TipoDireccion" />
          </CollapsibleSection>

          <CollapsibleSection id="contactos" title="CONTACTOS">
            <SubItem label="Tipo Contacto" route="/ContactoTipo" />
            <SubItem label="Clase Contacto" route="/ContactoClase" />
          </CollapsibleSection>

          <CollapsibleSection id="personas" title="PERSONAS Y EMPRESAS">
            <SubItem label="Persona/Empresa" route="/PersonaEmpresa" />
            <SubItem label="Relaciones" route="/Relaciones" />
            <SubItem label="Tipos de activos" route="/Activo" />
          </CollapsibleSection>

          <CollapsibleSection id="clientes" title="CLIENTES Y CARTERAS">
            <SubItem label="Clientes" route="/Cliente" />
            <SubItem label="Carteras" route="/Cartera" />
          </CollapsibleSection>

          <CollapsibleSection id="procesos" title="PROCESOS Y CAUSAS">
            <SubItem label="Tipo de proceso" route="/TipoProceso" />
            <SubItem label="Etapa" route="/Etapa" />
            <SubItem label="Concepto Deuda" route="/ConceptoDeuda" />
            <SubItem label="Concepto de gasto" route="/ConceptoGasto" />
            <SubItem label="Titulos" route="/Titulos" />
            <SubItem label="Origen de datos" route="/OrigenDatos" />
          </CollapsibleSection>

          <CollapsibleSection id="gestiones" title="GESTIONES">
            <SubItem label="Tipo de gestiones" route="/TipoGestiones" />
            <SubItem label="Resultados de gestiones" route="/ResultadoGestiones" />
          </CollapsibleSection>

          <CollapsibleSection id="otros" title="OTROS">
            <SubItem label="Moneda" route="/Moneda" />
            <SubItem label="Unidades" route="/Unidades" />
          </CollapsibleSection>
        </div>

        <Footer />
      </nav>
    );
  }

  // Default: solo logo y inicio
  return (
    <nav className="navbar navbar-inverse sidebar" id="sidebarHover" role="navigation">
      <div className="sidebarBrand" onClick={() => changePage("/Separacion")}>
        <img alt="logo" id="logo" src={logo} />
      </div>

      <div className="sidebarBody">
        <div className="sidebarSection">
          <div className="sidebarSectionTitle">PRINCIPAL</div>
          <NavItem icon={Icons.home} label="Inicio" route="/Separacion" />
        </div>
      </div>

      <Footer />
    </nav>
  );
};

export default withRouter(Sidebar);
